import { localePwaType } from '../en-US'

export const pwa: localePwaType = {
  installOurApp: 'Instala nuestra aplicación',
  playEverywhere: 'Instala la aplicación para jugar en todas partes',
  now: 'Ahora',
}
